import React from "react";
import PolicyPagesLayout from "../Layout/PolicyPagesLayout";
import TermsOfUsePolicy from "../Components/Pages/TermsOfUsePolicy";

const TermsOfUsePolicyPage = () => {
  return (
    <>
      <PolicyPagesLayout>
        <TermsOfUsePolicy />
      </PolicyPagesLayout>
    </>
  );
};

export default TermsOfUsePolicyPage;
